import { Button, DatePicker, Form, Input, Modal, Row, Select, Table, Col, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import Filter from '../../../components/Filter'
import UploadProfilePicture from '../../../components/UploadProfilePicture'

function FAQ() {
    const [form] = Form.useForm()
    const API_URL = import.meta.env.VITE_API_URL
    const accessToken = useSelector((state) => state.user.accessToken)
    const [FAQ, setFAQ] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [currentFAQ, setCurrentFAQ] = useState(null)
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 })
    const [selectedFilters, setSelectedFilters] = useState({ search: null });
    const [filterOptions, setFilterOptions] = useState([]);
    const [photo, setPhoto] = useState("");
    useEffect(() => {
        fetchFAQ()
    }, [])

    useEffect(() => {
        if (isModalVisible && currentFAQ) {
            form.setFieldsValue({
                question: currentFAQ.question,
                question_ar: currentFAQ.question_ar,
                answer: currentFAQ.answer,
                answer_ar: currentFAQ.answer_ar,
            });
        }
    }, [isModalVisible, currentFAQ, form]);

    const fetchFAQ = async (page = 1, pageSize = 10, search = null) => {
        setLoading(true)
        try {
            const params = {
                limit: pageSize,
                page: page,
                ...(search && { search })
            }

            const response = await axios.get(`${API_URL}FAQ/get-FAQs`, {
                params,
                headers: { Authorization: `Bearer ${accessToken}` }
            })
            setFAQ(response.data.FAQs)
            console.log(response.data)
            setPagination({
                current: page,
                pageSize: pageSize,
                total: response.data.totalCount
            })
        } catch (error) {
            console.error("Error fetching FAQ:", error)
            message.error("Failed to fetch FAQ")
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${API_URL}FAQ?id=${id}`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            })
            message.success("FAQ deleted successfully")
            fetchFAQ()
        } catch (error) {
            console.error("Error deleting FAQ:", error)
            message.error("Failed to delete FAQ")
        }
    }


    const handleSave = async (values) => {
        let payload = {};
        let hasImageChange = false;

        if (currentFAQ) {
            if (values.question !== currentFAQ.question) payload.question = values.question;
            if (values.question_ar !== currentFAQ.question_ar) payload.question_ar = values.question_ar;
            if (values.answer !== currentFAQ.answer) payload.answer = values.answer;
            if (values.answer_ar !== currentFAQ.answer_ar) payload.answer_ar = values.answer_ar;

            if (photo !== "" && photo !== currentFAQ.image) {
                payload.image = photo;
                hasImageChange = true;
            }


            if (Object.keys(payload).length === 0 && !hasImageChange) {
                message.info("No changes detected.");
                return;
            }
        } else {
            payload = {
                question: values.question,
                question_ar: values.question_ar,
                answer: values.answer,
                answer_ar: values.answer_ar,
                ...(photo && { image: photo })
            };

        }

        try {
            if (currentFAQ) {
                await axios.patch(`${API_URL}FAQ?id=${currentFAQ.id}`, payload, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                message.success("FAQ updated successfully");
            } else {
                await axios.post(`${API_URL}FAQ`, payload, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                message.success("FAQ created successfully");
            }

            setIsModalVisible(false);
            form.resetFields();
            setPhoto("");
            fetchFAQ();
        } catch (error) {
            console.error("Error saving FAQ:", error);
            message.error(`Failed to ${currentFAQ ? 'update' : 'create'} FAQ`);
        }
    };



    const handleFilterChange = (key, value) => {
        let updatedFilters = { ...selectedFilters };
        let errorMessageShown = false;


        if (key === "search") {
            let search = null;

            if (value && value.trim().length > 0) {
                if (value.length > 2) {
                    search = value.trim(); // Keep the search term as a string
                }
            }

            updatedFilters.search = search;
        }

        if (key === "") {
            fetchFAQ();
            updatedFilters = {};
        }

        setSelectedFilters(updatedFilters);

        fetchFAQ(1, pagination.pageSize, updatedFilters.search);
    };


    const columns = [
        { title: 'Question', dataIndex: 'question', key: 'question' },
        {
            title: 'View',
            render: (_, record) => (
                <Button onClick={() => {
                    setCurrentFAQ(record)
                    setIsModalVisible(true)
                }}>
                    View
                </Button>
            )
        },
        {
            title: 'Delete',
            render: (_, record) => (
                <Button style={{ borderRadius: 0, borderColor: "#FF4D4F", backgroundColor: "#FF4D4F", color: "#FFFFFF" }}
                    danger onClick={() => handleDelete(record.id)}>
                    Delete
                </Button>
            )
        }
    ]
    useEffect(() => {
        fetchFAQ(1, pagination.pageSize, selectedFilters.search);
    }, [pagination.pageSize, selectedFilters]);
    return (
        <div className="space-y-5">
            <Filter
                filterOptions={filterOptions}
                addItemName="Add FAQ"
                resetFilter={false}
                filterBy={false}
                setFilterOptions={setFilterOptions}
                addItemAction={() => {
                    setCurrentFAQ(null);
                    setIsModalVisible(true);
                }}
                onFilterChange={handleFilterChange}
                searchBarPlaceholder="Search FAQ"
            />

            <div className="table-responsive-wrapper responsive-table-container">
                <Table
                    className="customTable"
                    columns={columns}
                    dataSource={FAQ}
                    loading={loading}
                    rowKey="id"
                    pagination={pagination}
                    onChange={(pagination) => fetchOffers(pagination.current, pagination.pageSize)}
                />
            </div>

            <Modal
                title={currentFAQ ? "View FAQ" : "Add FAQ"}
                visible={isModalVisible}
                onCancel={() => {
                    setIsModalVisible(false);
                    setCurrentFAQ(null);
                    form.resetFields("");
                    setPhoto("");
                }}
                footer={null}
                width={800}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSave}
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <UploadProfilePicture
                                    value={photo || (currentFAQ ? currentFAQ.image : "")}
                                    onChange={(url) => setPhoto(url)}
                                />

                            </div>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Question (EN)"
                                name="question"
                                rules={[{ required: true, message: "Please enter question" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Question (AR)"
                                name="question_ar"
                                rules={[{ required: true, message: "Please enter question" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="Answer (EN)"
                                name="answer"
                                rules={[{ required: true, message: "Please enter answer" }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Answer (AR)"
                                name="answer_ar"
                                rules={[{ required: true, message: "Please enter answer" }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>

                    </Row>


                    <div className="flex justify-end gap-4">
                        <Button onClick={() => setIsModalVisible(false)}>Cancel</Button>
                        <Button type="primary" htmlType="submit">
                            {currentFAQ ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Form>
            </Modal>
        </div>

    )
}

export default FAQ